import { LinearGradient } from "expo-linear-gradient";
import { Box } from "native-base";
import React from "react";
import { createShimmerPlaceholder } from "react-native-shimmer-placeholder";
import styled from "styled-components/native";

const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

const ProductCardLoading = () => {
  return (
    <Box
      w={{
        base: "170px",
        lg: "200px",
      }}
      h="340px"
      rounded="lg"
      shadow="4"
      bgColor="white.50"
      m="2"
      justifyContent="flex-end">
      <Box rounded="lg">
        <Loader height={125} />
      </Box>
      <Box p="2">
        <Box my="2">
          <Loader height={22} />
        </Box>
        <Box my="2">
          <Loader width={120} height={22} />
        </Box>
        <Loader width={100} height={16} />
        <Box mt="8">
          <Loader height={40} />
        </Box>
      </Box>
    </Box>
  );
};

const Loader = styled(ShimmerPlaceholder)`
  width: ${({ width }) => (width ? width + "px" : "100%")};
  height: ${({ height }) => (height ? height + "px" : "100%")};
`;

export default ProductCardLoading;
